module.exports = __webpack_public_path__ + "img/logo-small.8e78d282.png";